module.exports = __webpack_public_path__ + "static/media/main idea.659f9052.mp3";